import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CloudRoundedIcon from "@mui/icons-material/CloudRounded";
import DevicesRoundedIcon from "@mui/icons-material/DevicesRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import VolunteerActivismRoundedIcon from "@mui/icons-material/VolunteerActivismRounded";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import { useTranslation } from "react-i18next";

const items = [
  {
    icon: <CloudRoundedIcon />,
    titleKey: "highlights.cloud.title",
    descriptionKey: "highlights.cloud.description",
  },
  {
    icon: <DevicesRoundedIcon />,
    titleKey: "highlights.responsive.title",
    descriptionKey: "highlights.responsive.description",
  },
  {
    icon: <AutoAwesomeRoundedIcon />,
    titleKey: "highlights.evolution.title",
    descriptionKey: "highlights.evolution.description",
  },
  {
    icon: <ManageAccountsRoundedIcon />,
    titleKey: "highlights.management.title",
    descriptionKey: "highlights.management.description",
  },
  {
    icon: <GroupRoundedIcon />,
    titleKey: "highlights.members.title",
    descriptionKey: "highlights.members.description",
  },
  {
    icon: <VolunteerActivismRoundedIcon />,
    titleKey: "highlights.donations.title",
    descriptionKey: "highlights.donations.description",
  },
];

export default function Highlights() {
  const { t } = useTranslation();

  return (
    <section id="highlight">
      <Box
        id="highlights"
        sx={{
          pt: { xs: 4, sm: 12 },
          pb: { xs: 8, sm: 16 },
          color: "white",
          bgcolor: "grey.900",
        }}
      >
        <Container
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 3, sm: 6 },
          }}
        >
          <Box
            sx={{
              width: { sm: "100%", md: "60%" },
              textAlign: { sm: "left", md: "center" },
            }}
          >
            <Typography component="h2" variant="h4" gutterBottom>
              {t("highlights.title")}
            </Typography>
            <Typography variant="body1" sx={{ color: "grey.400" }}>
              {t("highlights.subtitle")}
            </Typography>
          </Box>
          <Grid container spacing={2}>
            {items.map((item, index) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                <Stack
                  direction="column"
                  component={Card}
                  spacing={1}
                  useFlexGap
                  sx={{
                    color: "inherit",
                    p: 3,
                    height: "100%",
                    borderColor: "hsla(220, 25%, 25%, 0.3)",
                    backgroundColor: "grey.800",
                  }}
                >
                  <Box sx={{ opacity: "50%" }}>{item.icon}</Box>
                  <div>
                    <Typography gutterBottom sx={{ fontWeight: "medium" }}>
                      {t(item.titleKey)}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "grey.400" }}>
                      {t(item.descriptionKey)}
                    </Typography>
                  </div>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </section>
  );
}